module.exports = __webpack_public_path__ + "static/media/5.a5d824f8.jpg";